import styled from 'styled-components';
import { IconSizesType } from '../ThemeProvider/types';

export const SvgContainer = styled.div<{
  size: IconSizesType;
  clickable: boolean;
}>`
  width: ${({ theme, size }) => theme.basicIcon[size].size}px;
  height: ${({ theme, size }) => theme.basicIcon[size].size}px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};
`;
